import PropTypes from "prop-types"
import { Card, Typography } from "@mui/material"

import "../style.scss"

const SubscriptionCard = ({ id, style }) => {
  return <Card square className="dataset missing" style={style}>
    <div className="header">
      <div className="title">
        <Typography variant="h5" component="h5">{id || "Missing id"}</Typography>
        <div className="subheader">The metadata for this dataset is missing.</div>
      </div>
    </div>
  </Card>
}

SubscriptionCard.propTypes = {
  id: PropTypes.string,
  style: PropTypes.object,
}

export default SubscriptionCard
